import { COMPANY } from '../../../config/companyConfig.js';

/** Schema @id base — matches SEO team homepage specification (www). */
export const SCHEMA_SITE_ROOT = 'https://www.yovotrip.com/';

export const SCHEMA_IDS = {
  organization: `${SCHEMA_SITE_ROOT}#organization`,
  logo: `${SCHEMA_SITE_ROOT}#logo`,
  brand: `${SCHEMA_SITE_ROOT}#brand`,
  website: `${SCHEMA_SITE_ROOT}#website`,
  homepage: `${SCHEMA_SITE_ROOT}#homepage`,
};

const KNOWS_ABOUT = [
  'Flight Booking',
  'Domestic Flights',
  'International Flights',
  'Cheap Flights',
  'Airline Tickets',
  'Travel',
  'Business Travel',
  'Holiday Travel',
];

function buildSameAs() {
  const { social } = COMPANY;
  return [social.facebook, social.instagram, social.linkedin, social.twitter, social.youtube].filter(Boolean);
}

export function getSchemaLogoUrl() {
  const base = COMPANY.website.replace(/\/+$/, '');
  return `${base}/logo512.png`;
}

/**
 * Organization node — homepage graph only (not duplicated on other pages).
 * @param {{ description: string, logoUrl?: string }} params
 */
export function buildOrganizationSchema({ description, logoUrl = getSchemaLogoUrl() }) {
  return {
    '@type': 'Organization',
    '@id': SCHEMA_IDS.organization,
    name: COMPANY.brandName,
    url: SCHEMA_SITE_ROOT,
    logo: {
      '@type': 'ImageObject',
      '@id': SCHEMA_IDS.logo,
      url: logoUrl,
      contentUrl: logoUrl,
      width: 512,
      height: 512,
    },
    image: {
      '@id': SCHEMA_IDS.logo,
    },
    description,
    email: COMPANY.contact.supportEmail,
    telephone: COMPANY.contact.supportPhone,
    brand: {
      '@type': 'Brand',
      '@id': SCHEMA_IDS.brand,
      name: COMPANY.brandName,
    },
    areaServed: {
      '@type': 'Country',
      name: 'India',
    },
    knowsAbout: KNOWS_ABOUT,
    sameAs: buildSameAs(),
  };
}
